import { Link } from "react-router-dom";

export default function ThankYou() {
  return (
    <main
      className="min-h-[80vh] bg-[#F8FAFC] flex items-center"
      data-testid="thank-you-page"
    >
      <div className="mx-auto max-w-3xl px-5 sm:px-8 lg:px-12 py-20 text-center">
        <p className="text-xs font-bold tracking-widest uppercase text-[#C85A32] mb-5">
          Zelorq Analytics
        </p>
        <h1
          className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 leading-tight"
          data-testid="thank-you-title"
        >
          Gracias por suscribirse
        </h1>
        <p className="mt-6 text-base text-slate-600 leading-relaxed">
          Su solicitud fue recibida correctamente. Recibira nuestro boletin
          analitico semanal sobre el sector de recursos naturales de Argentina
          en la casilla de correo indicada. El primer dispatch llegara el
          proximo lunes a las 08:30 (GMT-3).
        </p>
        <p className="mt-4 text-sm text-slate-500">
          Si el mensaje no aparece en su bandeja de entrada, revise la carpeta
          de correo no deseado o agregue el remitente a su lista de contactos.
        </p>
        <div className="mt-10 flex justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center h-12 px-6 bg-[#0F2537] hover:bg-[#0a1c2b] text-white font-semibold text-sm tracking-wide rounded-sm"
            data-testid="thank-you-back-home"
          >
            Volver al inicio
          </Link>
        </div>
        <div className="mt-16 border-t border-[#E2E8F0] pt-8 text-xs text-slate-500">
          <p>
            Zelorq Analytics S.A. — CUIT 30-71829304-9 — Av. Leandro N. Alem
            855, Piso 12, Ciudad Autonoma de Buenos Aires, Argentina.
          </p>
        </div>
      </div>
    </main>
  );
}
